<template>
    <EmptyList
        v-if="!Array.isArray(checks) || !checks.length"
        :heading="'No Checks'"
        :message="'This vehicle doesn\'t have any insurance checks yet'"
    />

    <ul v-if="Array.isArray(checks) && checks.length"  role="list" class="grid grid-cols-1 gap-3">
        <AssetInsuranceChecksListItem
            v-for="check in checks"
            :check="check"
            :key="check.id"
            :refresh="refresh"
        />
    </ul>

</template>

<script>
import AssetInsuranceChecksListItem from "@par/asset/AssetInsuranceChecksListItem.vue"
export default {
    props: ['checks', 'refresh'],
    components: {
        AssetInsuranceChecksListItem
    }
}
</script>